import { getEasing } from './_easing.js';
import { object } from './_obj.js';
let Pie = {
	count: 0,
	max: 0,
	progress: 0,
	arc0: null,
	arc1: null,
	offset0: 0,
	offset1: 0,
	end0: 0,
	end1: 0,
	begin: 0,
	duration: 600,
	easing: "",
	timer: null,
	isShow: false,
	run: function(){
		let $this = this;
		setTimeout(function(){
			$this.begin = new Date();
			$this.animate(0);
		}, 600)
	},
	animate: function(count){
		let t = this;
		if(t.isShow){ return false}
		let end, arc, offset;
		if(count === 0){
			end = t.end0;
			arc = t.arc0;
			offset = t.offset0;
		}else{
			end = t.end1;
			arc = t.arc1;
			offset = t.offset1;
		}
		let current = new Date() - t.begin;
		if(current >= t.duration){
			current = t.duration;
		}
		//let progress = 1 - current/duration;
		let progress 		= current/t.duration;
		let easeProgress 	= t.easing(progress, 0, 1, 1);
		let currentPos = offset - end*easeProgress;
		//console.log(count, currentPos, offset, progress);
		if(progress >= 1){
			currentPos = end;
			if(count === 0){
				setTimeout(function(){
					t.begin = new Date();
					t.animate(1);
				}, 33/1000);
			}else{
				t.isShow = true;
			}
		}else{
			arc.style = `stroke-dashoffset: ${currentPos}px; stroke-dasharray: ${offset}px`;
			setTimeout(function(){
				t.animate(count);
			}, 33/1000);
		}
	},
	reset: function(){
		let arc0 = this.arc0;
		let arc1 = this.arc1;
		
		arc0.style = `stroke-dashoffset: ${this.offset0}px; stroke-dasharray: ${this.offset0}px`;
		arc1.style = `stroke-dashoffset: ${this.offset1}px; stroke-dasharray: ${this.offset1}px`;
	}
}
let pieCharts = [];
export let chart = {
	pieArc0: null,
	pieArc1: null,
	easing: "",
	pie: function(){
		pieCharts = [];
		let pies = document.querySelectorAll("[data-chart-pie]");
		pies.forEach( ( $pie ) => {
			let _p = object(Pie);
			_p.count 	= parseFloat( $pie.getAttribute("data-count") );
			_p.max 		= parseInt( $pie.getAttribute("data-next-step") );
			_p.progress = (_p.count/_p.max).toFixed(4);
			let p0, p1;
			if(_p.count > _p.max){
				p0 = 1;
				p1 = ( (_p.count - _p.max) / _p.max).toFixed(4);
			}else{
				p0 = (_p.count/_p.max).toFixed(4);
				p1 = 0;
			}
			_p.arc0 	= $pie.querySelector(".arc0");
			_p.arc1 	= $pie.querySelector(".arc1");
			_p.offset0 	= 905;
			_p.offset1 	= 1020;
			_p.end0 	= _p.offset0*(p0);
			_p.end1 	= _p.offset1*(p1);
			_p.duration = 600;
			_p.easing 	= getEasing("easeInOutCubic");
			_p.isShow 	= false;
			pieCharts.push(_p);
			//console.log(_p);
		});
		chart.runPie(1);
	},
	runPie: function(num){
		pieCharts[num].run();
	},
	reset: function(){
		for(let i = 0; i < pieCharts.length; i++){
			pieCharts[i].reset();
		}
	}
}